<template>
  <div v-if="loaded" class="application" :class="{ 'application--videoresume': isVideoresume }">
    <div class="application__wrap">
      <v-container class="container-fixed">
        <v-row justify="center">
          <v-col sm="4" md="4" lg="4">
            <div v-if="!sent" class="application__form" @click="hide_calend">
              <div v-if="company_logo" class="application__logo">
                <img :src="company_logo" alt="Company logo" />
              </div>
              <div class="application__name">
                {{
                  isVideoresume
                    ? $tr('vacancy.openRegistrationVideoresume.resumeTitle.applicationTitle')
                    : $tr('vacancy.preferences.settings.application')
                }}
              </div>
              <div class="application__quest-lng">
                <span>
                  {{
                    isVideoresume
                      ? $tr('vacancy.openRegistrationVideoresume.resumeTitle.applicationQuestions')
                      : `${$tr('interview.tests.questions.questions')}:`
                  }}
                </span>
                <span>{{ questions.length }}</span>
              </div>

              <div v-for="(item, k) in questions" :key="item.id" class="question">
                <p v-if="!item.is_required" class="question__non-required">
                  {{ $t('videoInterview.notMandatoryQuestion') }}
                </p>
                <div class="question__title">
                  <div class="number">{{ k + 1 }}.</div>
                  <span v-html="item.name"></span>
                </div>

                <div class="text">
                  <component
                    :is="item.type"
                    :id="item.id"
                    :data="item.answers"
                    :configuration="item.configuration"
                    :current_locale="current_locale"
                    :hide_mobile_calend="hide_mobile_calend"
                    :placeholder="'vacancy.preferences.application.dateHolder'"
                    :is-videoresume="isVideoresume"
                    @update="update"
                    @set_valid_date="set_valid_date"
                    @set_mobile_calend="set_mobile_calend"
                  />
                </div>
              </div>

              <div class="but-wrapper">
                <vbutton
                  v-if="!isVideoresume"
                  class="but"
                  :disabled="!can_save || !valid_date"
                  :label="$tr('vacancy.preferences.application.sent')"
                  :loading="loading || isLoading"
                  @click="save"
                />

                <vresume-button
                  v-else
                  class="but"
                  :disabled="!can_save || !valid_date"
                  :label="$tr('vacancy.openRegistrationVideoresume.resumeTitle.applicationGoNext')"
                  :loading="loading || isLoading"
                  @click="save"
                />
              </div>
            </div>

            <div v-else class="refuse-container-wrapper">
              <div class="refuse-container">
                <div class="refuse-container__wrap">
                  <img src="/static/images/elements/icon_ok.svg" />
                  <div
                    :class="[
                      'refuse-container__title',
                      {
                        'refuse-container__title_jp': current_locale === 'ja'
                      }
                    ]"
                  >
                    {{ $tr('vacancy.preferences.application.sentApplication') }}
                  </div>
                  <div class="refuse-container__answers">
                    {{ $tr('interview.tests.end.answersSend') }}
                  </div>
                  <vbutton
                    v-if="active_modules.length > 1 && !dropout"
                    class="refuse-container__but"
                    :label="label"
                    @click="go_next"
                  />
                </div>
              </div>
              <!-- <div v-if="!(active_modules.length > 1 && !dropout)" class="refuse-note">
                <div v-html="$tr('interview.end.note2', { link: noteLink })"></div>
              </div> -->
            </div>
          </v-col>
        </v-row>
      </v-container>
    </div>
  </div>
</template>

<script>
import { STORE_PREFIX } from './constants.js';
import isMobile from 'ismobilejs';
import single from './components/choice.vue';
import multiple from './components/multiple.vue';
import enumeration from './components/enumeration.vue';
import open from './components/open.vue';
import date from './components/date.vue';
import file from './components/file.vue';

export default {
  name: 'ApplicationDefault',

  components: {
    single,
    multiple,
    enumeration,
    open,
    date,
    file
  },

  props: {
    token: [String, Number],
    interview: Object,
    isVideoresume: Boolean,
    loaded: Boolean
  },

  data() {
    return {
      sent: false,
      dropout: false,
      valid_date: true,
      isMobile: isMobile.any,
      hide_mobile_calend: true,
      regexTextInTags: /(<([^>]+)>)/gi,
      isLoading: false
    };
  },

  computed: {
    landing() {
      return this.$store.getters['landing/item'];
    },

    can_save() {
      let answersLength = 0;

      this.required_answers.forEach(answer => {
        if (
          !!answer.answers ||
          !!answer.enumeration_items ||
          answer.other !== undefined ||
          answer.text !== undefined ||
          answer.file !== undefined ||
          answer.date !== undefined ||
          !!answer.answer_id
        ) {
          answersLength += 1;
        }
      });

      return answersLength === this.required_questions.length;
    },

    required_questions() {
      return this.questions.filter(q => !!q.is_required);
    },

    required_answers() {
      return this.answers.filter(a => this.required_questions.findIndex(q => q.id == a.question_id) > -1);
    },

    noteLink() {
      switch (this.current_locale) {
        case 'ru':
          return 'https://www.vcv.me/ru';
        case 'ja':
        case 'jp':
          return 'https://me.vcv.ai/r/jp';
        default:
          return 'https://www.vcv.me/';
      }
    },

    list() {
      return this.$store.getters['interview/application/list'];
    },

    questions() {
      return this.list ? this.list.questions : [];
    },

    answers() {
      return this.$store.getters['interview/application/answers'];
    },

    current_locale() {
      return this.$store.getters['locale/current'];
    },

    company_logo() {
      return this.interview && this.interview.company ? this.interview.company.logo : false;
    },

    loading() {
      return this.$store.getters['interview/application/loaded'];
    },

    active_modules() {
      return this.interview ? this.interview.active_modules : false;
    },

    vacancy_country() {
      return this.interview && this.interview.vacancy && this.interview.vacancy.country
        ? this.interview.vacancy.country.code
        : null;
    },

    label() {
      if (this.active_modules.length === 1) {
        return 'vacancy.preferences.application.sent';
      } else {
        return 'interview.tests.endTime.next';
      }
    },

    company_language() {
      return this.interview.company && this.interview.company.language ? this.interview.company.language.code : '';
    }
  },

  watch: {
    sent(val) {
      if (val && this.active_modules.length <= 1) {
        if (window.gtag) {
          window.gtag({ event: 'response_received' });
        }
      }
    },

    vacancy_country: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$store.commit('interview/set_country', val);
        }
      }
    },

    company_language: {
      immediate: true,
      handler(val) {
        if (val) {
          this.$store.commit('interview/set_company_language', val);
        }
      }
    }
  },

  async created() {
    await this.load();
  },

  methods: {
    async load() {
      await this.$store.dispatch('interview/application/load', this.token);
    },

    landingLoad() {
      this.$store.dispatch('landing/load', this.token);
    },

    async save() {
      this.isLoading = true;

      await this.$store
        .dispatch('interview/application/record', {
          records: this.answers,
          token: this.token
        })
        .then(() => {
          return this.$store.dispatch('interview/application/finish', this.token);
        })
        .then(() => {
          return this.$store.dispatch(STORE_PREFIX + 'interview/load', this.token);
        })
        .then(r => {
          let finish = r.data.data[0].stage.id === 'finished';
          if (finish) {
            // this.$router.push({name: 'interview', params: {token: this.token}})
            this.dropout = true;
          }

          if (!this.isVideoresume) {
            this.sent = true;
            this.$emit('sent', true);
            return r;
          }
          this.go_next();
        })
        .finally(() => {
          this.isLoading = false;
        });
    },

    go_next() {
      // this.$store.commit('interview/videointerview/next_stage');
      this.$store.commit('interview/application/set_finish', true);
      if (this.active_modules.find(el => el.id === 'test')) {
        this.$router.push({
          name: 'interview-test',
          params: { token: this.token }
        });
      } else if (this.active_modules.find(el => el.id === 'videointerview')) {
        this.$router.push({ name: 'record', params: { token: this.token } });
      } else {
        this.$router.push({ path: `/interviews/${this.token}` });
      }
      this.sent = false;
      this.$emit('sent', false);
    },

    update(v) {
      const isAnswerValid = this.validate_answer(v);

      if (!isAnswerValid) {
        return this.$store.commit('interview/application/remove_empty_answer', v.question_id);
      }

      this.$store.commit('interview/application/update', v);
    },

    validate_answer(answer) {
      if ('text' in answer) {
        const textInTags = answer.text.replace(this.regexTextInTags, '');
        return !!textInTags.length;
      }

      if ('date' in answer && answer.date.length) return true;
      if ('answers' in answer && answer.answers.length) return true;

      if ('answers' in answer) {
        if (answer.answers.length) return true;

        if ('other' in answer) {
          const textInTags = answer.other.replace(this.regexTextInTags, '');
          return !!textInTags.length;
        }
      }

      if ('enumeration_items' in answer && answer.enumeration_items.length) return true;

      if ('enumeration_items' in answer) {
        if (answer.enumeration_items.length) return true;

        if ('other' in answer) {
          const textInTags = answer.other.replace(this.regexTextInTags, '');
          return !!textInTags.length;
        }
      }

      if ('answer_id' in answer) {
        if (typeof answer.answer_id == 'number') return true;

        if ('other' in answer) {
          const textInTags = answer.other.replace(this.regexTextInTags, '');
          return !!textInTags.length;
        }
      }
      if ('file' in answer && answer.file.length) return true;
      return false;
    },

    set_valid_date(v) {
      this.valid_date = v;
    },

    set_mobile_calend(v) {
      // if(this.isMobile) {
      //   this.hide_mobile_calend = v;
      // }
    },

    hide_calend() {
      this.hide_mobile_calend = true;
    }
  }
};
</script>

<style lang="scss" scoped>
  .application {
    width: 100%;
    height: 100%;

    &__wrap {
      width: 100%;
      margin: 0 auto;
      background: #fff;

      @media (max-width: 460px) {
        width: 100%;
      }
    }

    &__form {
      padding: 52px 0;
    }

    &__logo {
      margin-bottom: 52px;
      img {
        width: 140px;
        max-width: 140px;
        height: auto;
      }

      @media (max-width: 460px) {
        margin-bottom: 29px;

        img {
          display: block;
          margin: 0 auto;
          width: 70px;
          height: auto;
        }
      }
    }

    &__name {
      margin-bottom: 20px;
      font-style: normal;
      font-weight: bold;
      font-size: 24px;
      line-height: 32px;
      color: #233346;
    }

    &__quest-lng {
      margin-bottom: 36px;
      color: #9faab6;
      font-weight: normal;
      font-size: 15px;
      line-height: 24px;

      span:last-child {
        color: #233346;
        padding-left: 4px;
      }
    }

    .question {
      margin-bottom: 36px;

      &:last-child {
        margin-bottom: 0;
      }

      &__non-required {
        color: #9faab6;
        font-weight: 500;
        line-height: 24px;
        font-size: 15px;
        margin-right: 4px;
      }

      &__title {
        font-weight: 700;
        line-height: 20px;
        font-size: 15px;
        letter-spacing: 0.005em;
        color: #233346;
        word-wrap: break-word;
        display: flex;
        align-items: flex-start;
        margin-bottom: 12px;

        ::v-deep p {
          margin: 0;
        }

        .number {
          color: #9faab6;
          font-weight: 500;
          line-height: 22px;
          font-size: 15px;
          margin-right: 7px;
        }
      }

      .text {
        width: 100%;
        white-space: pre-wrap;
      }
    }
  }
  .refuse-container-wrapper {
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: relative;
  }
  .refuse-container {
    margin: 0 auto;
    display: flex;
    align-items: center;
    justify-content: center;
    background: white;
    box-sizing: border-box;

    @media (max-width: 768px) {
      padding: 0;
    }
    &__wrap {
      padding: 40px 0;
      max-width: 500px;
      color: #233346;
      text-align: center;
    }
    &__title {
      font-style: normal;
      font-weight: bold;
      font-size: 24px;
      line-height: 32px;
      margin-top: 15px;

      &_jp {
        max-width: 310px;
      }
    }

    &__answers {
      margin-top: 20px;
      font-size: 15px;
      line-height: 24px;
    }

    &__but {
      margin-top: 20px;
    }
  }

  .refuse-note {
    position: relative;
    top: 62px;
    margin-top: 0;
    margin-left: 20px;
    margin-right: 20px;
    font-style: normal;
    font-weight: normal;
    font-size: 15px;
    line-height: 20px;
    text-align: center;
    color: #233346;

    @media (max-width: 767px) {
      top: 0;
      margin-top: 8px;
    }

    div {
      margin-bottom: 13px;
    }

    ::v-deep a {
      color: #bc89e6;

      &:hover {
        color: #bc89e6;
      }
    }
  }

  .but-wrapper {
    display: flex;
    width: 100%;
    justify-content: flex-end;

    @media (max-width: 767px) {
      justify-content: center;
    }
  }

  .application {
    margin-bottom: 100px;

    &.application--videoresume {
      .application__wrap {
        background: #ffffff;
        box-shadow: 0px 0px 25px rgba(35, 51, 70, 0.05);
        border-radius: 4px;
      }
      .application__logo {
        text-align: center;

        img {
          height: auto;
          width: auto;
          max-width: initial;
          max-height: 70px;
        }
      }

      .application__name {
        margin-bottom: 16px;
        // font-family: 'Euclid Circular A';
        font-style: normal;
        font-weight: bold;
        font-size: 24px;
        line-height: 32px;
        text-align: center;
        color: #555555;
      }

      .application__quest-lng {
        margin-bottom: 36px;
        // font-family: 'Euclid Circular A';
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 24px;
        text-align: center;
        color: #c4b9d3;

        span {
          color: #8d8d8d;
        }
      }

      .question__title {
        margin-bottom: 8px;
        // font-family: 'Euclid Circular A';
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 24px;
        color: #555555;
      }

      .text {
        // font-family: 'Euclid Circular A';
        font-style: normal;
        font-weight: normal;
        font-size: 15px;
        line-height: 24px;
        color: #8d8d8d;

        ::v-deep {
          .vcheckbox {
            border-image-source: linear-gradient(
              278deg,
              #848bd3 0%,
              #bc89e5 100%
            );
            border-image-slice: 1;

            &.checked {
              background-image: url(/static/images/elements/vcv-checked.svg),
                linear-gradient(278deg, #848bd3 0%, #bc89e5 100%);
            }
          }

          .vcircle {
            justify-content: center;
            align-items: center;
            border: 0;
            background: linear-gradient(278deg, #848bd3 0%, #bc89e5 100%);
            opacity: 1;
            position: relative;

            &:after {
              content: '';
              width: 14px;
              height: 14px;
              position: absolute;
              top: 2px;
              left: 2px;
              background: #fff;
              border-radius: 50%;
            }

            &.checked {
              .point {
                background: linear-gradient(278deg, #848bd3 0%, #bc89e5 100%);
                position: relative;
                z-index: 1;
                margin: auto;
                display: flex;
                min-width: auto;
                min-height: auto;
              }
            }
          }
        }
      }
    }
  }
</style>
